<template>
    <v-snackbar v-model="show" :timeout="-1" location="top" primary>
        <v-row no-gutters>
            <v-col :cols="12">
                {{
                    offersToCompareCount
                        ? `${$t('selected_for_compare_count')}: ${offersToCompareCount}`
                        : $t('select_to_compare_text')
                }}
                <v-btn
                    v-show="productType === 'hotel' && offersToCompareCount > 1"
                    size="small"
                    color="primary"
                    class="ml-4 mr-4"
                    @click="redirectToCompare"
                >
                    {{ $t('compare') }}
                </v-btn>
                <v-btn v-show="offersToCompareCount > 0" size="small" variant="outlined" @click="clearOffersToCompare">
                    {{ $t('clear_compare') }}
                </v-btn>
            </v-col>
            <v-col v-show="offersToCompareCount" :cols="12" class="mt-2">
                <download-search-results
                    :product-type="productType"
                    :search-request="searchRequest"
                    :city="city"
                    :departure-point="departurePoint"
                />
            </v-col>
        </v-row>
    </v-snackbar>
</template>

<script lang="ts">
    import {Component, Model, Prop, Vue} from 'vue-facing-decorator'
    import DownloadSearchResults from '@/components/snippets/DownloadSearchResults.vue'

    @Component({
        components: {
            DownloadSearchResults,
        },
    })
    export class CompareSnackbar extends Vue {
        @Model() show: boolean
        @Prop({default: 'hotel', type: String}) productType
        @Prop() searchRequest
        @Prop() city
        @Prop() departurePoint

        clearOffersToCompare() {
            this.$emit('close-comparison')
        }

        get offersToCompareCount() {
            if (this.productType === 'transfer') {
                return transfersStore.offersToCompare.reduce((offers, product) => {
                    if (product.offersKeys?.length) {
                        return [...offers, ...product.offersKeys]
                    }

                    return offers
                }, []).length
            }

            return hotelsStore.offersToCompare.filter(({rooms}) => rooms?.length).length
        }

        redirectToCompare() {
            if (this.productType === 'hotel') this.$router.push({name: 'comparison'})
            if (this.productType === 'transfer') this.$router.push({name: 'transfersComparison'})
        }
    }

    export default CompareSnackbar
</script>
